export const paginationDefaults = {
  firstPageIndex: 1,
  serverPageOffset: 1,
  itemsPerPage: 10,
  allItemsInPage: 9999,
  dashboardPageSize: 5,
  totalCount: 0,
};
